module.exports = {
    routes: [
        {
            path: '/',
            name: 'home',
            component: require('./pages/Home').default,
        },
        {
            path: '/kontakt',
            name: 'contact',
            component: require('./pages/Contact').default,
        },
        {
            path: '/betingelser',
            name: 'terms',
            component: require('./pages/Terms').default,
        },
        {
            path: '/om-os',
            name: 'about',
            component: require('./pages/About').default,
        },
        {
            path: '/bliv-studerende',
            redirect: '/bliv-student-freelancer'
        },
        {
            path: '/bliv-student-freelancer',
            name: 'new-student',
            component: require('./pages/NewStudent').default,
        },
        {
            path: '*',
            redirect: '/',
        },
    ],
};



// WEBPACK FOOTER //
// ./src/infrastructure/home/routes.js